exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-treeselect__control{font-size:.875rem!important}.payments-table{height:75vh;font-size:9pt}.payments-table .payments-table-style-actions{min-width:120px}.payments-table .payments-table-style-actions .actions-icons{text-align:center;white-space:nowrap}.payments-table .payments-table-style-th-datetime{min-width:110px}.payments-table .payments-table-style-td-datetime{text-align:center}", ""]);

// exports
